import { IAuthenticationModel, ILoginWithChangeModel, IOldAuthenticationModel, IPasswordComplecityModel } from "./model/IAuthenticationModel";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class AuthenticationService extends ServiceBase {

    public async postLogin(username: string, password: string,
    ): Promise<Result<IAuthenticationModel>>
    {
        let url = "/Authentication/login";

        var result = await this.requestJson<IAuthenticationModel>({
            url: url,
            data: { username: username, password: password },
            method: "POST"
        });
        return result;
    }

    public async postLoginWithChange(username: string, oldPassword: string, newPassword: string
    ): Promise<Result<ILoginWithChangeModel>> {
        let url = "/Authentication/loginWithChange";

        var result = await this.requestJson<ILoginWithChangeModel>({
            url: url,
            data: { username: username, oldPassword: oldPassword, newPassword: newPassword },
            method: "POST"
        });
        return result;
    }

    public async postResetPasswordEmail(email: string
    ): Promise<DefaultResult> {
        let url = "/Authentication/SendResetPasswordEmail?email=" + email;

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST"
        });
        return result;
    }

    public async postResetPassword(token: string, newPassword: string
    ): Promise<Result<IPasswordComplecityModel>> {
        let url = "/Authentication/ResetPassword";

        var result = await this.requestJson<IPasswordComplecityModel>({
            url: url,
            data: { token: token, newPassword: newPassword },
            method: "POST"
        });
        return result;
    }

    public async postLogout(): Promise<Result<boolean>> {
        let url = "/Authentication/Logout";

        var result = await this.requestJson<boolean>({
            url: url,
            method: "POST"
        });
        return result;
    }

    public async getToken(
        token: string,
    ): Promise<Result<boolean>> {
        let url = "/Authentication/ResetPassword/Token/" + token;

        var result = await this.requestJson<boolean>({
            url: url,
            method: "GET"
        });
        return result;
    }

    //#########################Ye olde code#########################
    public async postOldLogin(username: string, password: string,
    ): Promise<Result<IOldAuthenticationModel>> {
        let url = "/API/Authentication/login";
        //let url = "http://localhost:5024/Authentication/login";

        var result = await this.requestOldJson<IOldAuthenticationModel>({
            url: url,
            data: { username: username, password: password },
            method: "POST"
        });
        return result;
    }
    public async postOldLogout(): Promise<Result<boolean>> {
        let url = "/API/Authentication/Logout";
        //let url = "http://localhost:5024/Authentication/Logout";

        var result = await this.requestOldJson<boolean>({
            url: url,
            method: "POST"
        });
        return result;
    }

}